import { useQuery } from "@tanstack/react-query";
const { get } = require("api/requests");

const getListByCourseId = async (id, params) => get(`assign-history/${id}`, params);

export const useGetAssignHistory = (id, params = {}) => {
  return useQuery(['assign-history', params], () => getListByCourseId(id, params), {
    enabled: true
  })
}